import { SHIPPING_METHOD } from "../../../../constants";

export const CourierPickup = ({ tabRef, handleChangeMethod }) => {
  return (
    <div className="nav-item delivery-method-item" role="presentation">
      <div
        ref={tabRef}
        className="nav-link"
        id="pills-courier-tab"
        data-bs-toggle="pill"
        data-bs-target="#pills-courier"
        type="button"
        role="tab"
        aria-controls="pills-courier"
        aria-selected="false"
        onClick={(e) => {
          handleChangeMethod(e, SHIPPING_METHOD[3]);
        }}
      >
        <div className="delivery-selection">
          <p className="choose-checkout" />
          <h6>Courier Pick Up</h6>
        </div>
        <span className="wes-checkout-courier" />
      </div>
    </div>
  );
};
